/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlanResponseDto
 */
export interface PlanResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    organizationId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PlanResponseDto
     */
    isShared: boolean;
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    priority: PlanResponseDtoPriorityEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PlanResponseDto
     */
    active: boolean;
    /**
     * Days ahead of due date when ticket generation may create a Preventive Ticket
     * @type {number}
     * @memberof PlanResponseDto
     */
    schedulingHorizonDays: number;
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    createdById: string;
    /**
     * 
     * @type {string}
     * @memberof PlanResponseDto
     */
    updatedById: string;
    /**
     * 
     * @type {Date}
     * @memberof PlanResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof PlanResponseDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const PlanResponseDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type PlanResponseDtoPriorityEnum = typeof PlanResponseDtoPriorityEnum[keyof typeof PlanResponseDtoPriorityEnum];


/**
 * Check if a given object implements the PlanResponseDto interface.
 */
export function instanceOfPlanResponseDto(value: object): value is PlanResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isShared' in value) || value['isShared'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('schedulingHorizonDays' in value) || value['schedulingHorizonDays'] === undefined) return false;
    if (!('createdById' in value) || value['createdById'] === undefined) return false;
    if (!('updatedById' in value) || value['updatedById'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function PlanResponseDtoFromJSON(json: any): PlanResponseDto {
    return PlanResponseDtoFromJSONTyped(json, false);
}

export function PlanResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlanResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'isShared': json['isShared'],
        'code': json['code'],
        'name': json['name'],
        'priority': json['priority'],
        'active': json['active'],
        'schedulingHorizonDays': json['schedulingHorizonDays'],
        'createdById': json['createdById'],
        'updatedById': json['updatedById'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function PlanResponseDtoToJSON(json: any): PlanResponseDto {
    return PlanResponseDtoToJSONTyped(json, false);
}

export function PlanResponseDtoToJSONTyped(value?: PlanResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'isShared': value['isShared'],
        'code': value['code'],
        'name': value['name'],
        'priority': value['priority'],
        'active': value['active'],
        'schedulingHorizonDays': value['schedulingHorizonDays'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

